import React from 'react';
export default (props) => 

<svg width={props.iconWidth} height={props.iconHeigth} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.92581 2.22824C3.1537 2.48873 -1.42097 8.80851 0.403095 18C3.05873 8.5648 9.92581 9.53965 9.92581 9.53965V12.2205L18 6.09284L9.92581 0V2.22824Z" fill="#1CB6CC"/>
</svg>
